import { paths } from 'config'
import { DrawerTenants } from 'shared/assets'
import { Loadable } from 'shared/components'
import { ModuleRoute } from 'shared/types'

const routes: ModuleRoute[] = [
  {
    path: paths.visitorCheckInTargets,
    canShowVisitorPanelCheckIns: true,
    exact: true,
    linkSettings: {
      icon: DrawerTenants,
      label: 'nav.visitorCheckInTargets',
      to: paths.visitorCheckInTargets,
    },

    component: Loadable({
      component: () => import('./pages/VisitorCheckInTargets'),
    }),
    layoutSettings: {},
  },
]

export default routes
